import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ErrorView from '../../components/ErrorView'
import LoadingScreen from '../../components/LoadingScreen'
import ShowRefundView from './ShowRefundView'

const ShowRefundApp = () => {
  const { id } = useParams() 

  const [isFetching, setIsFetching] = useState(true)
  const [details, setDetails] = useState(null)
  const [defaultDetails, setDefaultDetails] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (id) fetchTransactionDetails()
  }, [id])

  const fetchTransactionDetails = async ({ silent = false } = {}) => {
    if (!silent) setIsFetching(true)

    try {
      const response = await authFetch(`${BASE_BACKEND_URL}/refunds/${id}`, { method: 'GET' })
      if (!response) return

      if (response.status === 404) {
        setError('No se encontró la actividad')
        return
      }

      const data = await response.json()
      if (data.error) {
        setError(data.message)
      } else {
        setDetails(data)
        setDefaultDetails(data)
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsFetching(false)
    }
  }

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  }

  if (error) {
    return <ErrorView error={error} />
  }

  return (
    <ShowRefundView
      details={details}
      defaultDetails={defaultDetails}
      position={id}
      onRefresh={() => fetchTransactionDetails({ silent: true })}
    />
  )
}

export default ShowRefundApp
